import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import { memo, useState } from "react";
import { chatListType, TypeChat } from "../../../../core/api/chatsApi";
import { ROLES } from "../../../../core/consts/common";
import { dateWithTimeConverter } from "../../../../core/helpers/dateConverter";
import { CurrentUserState } from "../../../../core/types/currentUser";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxSender: {
      padding: "24px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "white",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#F2F2F2",
        cursor: "pointer",
      },
    },
    messageInfoWrap: {
      maxWidth: "100%",
      flexDirection: "column",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
    messageInfoWrap2: {
      maxWidth: "100%",
      // flexDirection: 'column',
      gap: "12px",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
    messageInfoWrap3: {
      maxWidth: "100%",
      flexDirection: "column",
      display: "flex",
      alignItems: "flex-end",
    },
    messageInfo: {
      paddingRight: "5px",
      color: "#B0BFC6",
      wordBreak: "break-all",
      width: "fit-content",
      overflow: "hidden",
    },
    message: {
      //styleName: P2;
      fontFamily: "Gilroy",
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "21px",
      textAlign: "left",
      color: "#7990A5",

      wordBreak: "break-all",
      width: "fit-content",
      overflow: "hidden",
      // height: "18px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "inline-block",
    },
    support__message_date: {
      //styleName: account/P3_ACC;
      fontFamily: "Gilroy",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "19px",
      textAlign: "right",
      color: "#7990A5",
    },
    bankName: {
      maxWidth: "fit-content",
      marginLeft: "15px",
      color: "#7990A5",
    },
    messagesCount: {
      width: "fit-content",
      padding: "2px 8px",
      backgroundColor: "#4794EF",
      borderRadius: "10px",
      color: "#ffffff",
      justifyContent: "center",
    },
    support__title_mes: {
      //styleName: account/P2_BOLD_ACC;
      fontFamily: "Gilroy",
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "21px",
      textAlign: "left",
    },
    avatar__container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatar__img_user: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      objectFit: "cover",
    },
    avatar__img_bank: {
      width: "40px",
      height: "40px",
      borderRadius: "4px",
      objectFit: "cover",
    },
  })
);

type Props = {
  handleChatRouteClick: (chat: chatListType) => void;
  chat: chatListType;
  initialUser: CurrentUserState;
  avatar: string;
  bankIcon: string;
  isShowLeadChat?: boolean;
};

const MessageNewSupport: React.FC<Props> = (props) => {
  const classes = useStyles();
  const [unReadMes, setUnReadMes] = useState<number>(
    props.chat.countUnreadMessage
  );

  const handleMessageClick = () => {
    props.handleChatRouteClick(props.chat);
    setUnReadMes(0);
  };

  return (
    <div
      className={classes.boxSender}
      onClick={handleMessageClick}
      key={props.chat.id}
    >
      <div className={classes.messageInfoWrap2}>
        <div className={classes.avatar__container}>
          {
            <img
              className={
                props.isShowLeadChat || props.chat.leadId === null
                  ? classes.avatar__img_user
                  : classes.avatar__img_bank
              }
              alt="avatar"
              src={
                props.isShowLeadChat || props.chat.leadId === null
                  ? props.avatar
                  : props.bankIcon
              }
            />
          }
        </div>

        <div
          className={classes.messageInfoWrap}
          style={{ justifyContent: "space-between" }}
        >
          <p className={classes.support__title_mes}>
            {props.chat.typeChat === TypeChat.Bank &&
            props.initialUser.role === ROLES.PARTNER
              ? props.chat.nameChat
              : props.chat.typeChat === TypeChat.ManagerChat
                ? props.initialUser.role === ROLES.MANAGER
                  ? `Чат с ${
                      props.chat.roleInterlocutor === "agent"
                        ? "агентом"
                        : "клиентом"
                    } ${props.chat.nameInterlocutor}`
                  : `${props.chat.nameInterlocutor}` // !!
                : props.chat.nameChat === "Техподдержка"
                  ? "Чат с техподдержкой"
                  : "Заявка"}
            {props.chat.leadId
              ? ` ${props.chat.leadId}`
              : props.chat.typeChat === TypeChat.Role &&
                  props.initialUser.role === ROLES.MANAGER
                ? props.chat.nameChat
                : ""}
            {props.chat.bankName && (
              <Typography
                variant="body2"
                component="span"
                className={classes.bankName}
              >
                {props.chat.bankName}
              </Typography>
            )}
          </p>
          <Box className={classes.messageInfoWrap}>
            <Typography
              variant="body2"
              component="span"
              className={classes.message}
              style={{
                maxWidth: `${props.chat.lastMessageYou ? "540px" : "540px"}`,
              }}
            >
              {props.chat.lastMessage}
            </Typography>
          </Box>
        </div>
      </div>
      <div className={classes.messageInfoWrap3}>
        <div className={classes.support__message_date}>
          {dateWithTimeConverter(props.chat.lastTimeMessage)}
        </div>

        <div>
          {unReadMes > 0 && (
            <Typography
              variant="body2"
              component="span"
              className={classes.messagesCount}
            >
              {unReadMes}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(MessageNewSupport);
